<template>
    <section class="section my-6">
        <div class="container">
            <h2 class="cp-title-2 mb-1 mt-2">{{ faq.title }}</h2>
            
            <div class="cp-line-lh my-2" :style="computedBackgroundColor"></div>

            <div>
                <b-collapse 
                v-for="(item, index) in filteredItems" :key="index" 
                class="card mt-5"
                style="max-width: 67rem"
                animation="slide" 
                aria-id="contentIdForA11y3"
                :open="isOpen == index"
                @open="isOpen = index"
            >
                    <div
                        slot="trigger" 
                        slot-scope="props"
                        class="card-header"
                        role="button"
                        aria-controls="contentIdForA11y3">
                        <a class="card-header-icon">
                            <b-icon
                                :style="isLightTheme ? 'color: #9A9CB8' : computedStyle"
                                pack="fas"
                                size="is-small"
                                :icon="props.open ? 'plus' : 'plus'">
                            </b-icon>
                        </a>
                        <p class="card-header-title has-text-weight-normal" style="color: #3B4050">
                            {{ item.question }}
                        </p>
                    </div>

                    <div class="card-content">
                        <div class="content">
                            {{ item.answer }}
                        </div>
                    </div>
                </b-collapse>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'
import RateColor from '@/mixins/RateColor'

export default {
    data: () => ({
        isOpen: 0,
    }),
    mixins: [ RateColor ],
    computed: {
        ...mapGetters({
            faq: 'company/faq',
            primary_color: 'company/primary_color',
        }),
        computedStyle(){
            return {
                'color': this.primary_color,
            }
        },
        computedBackgroundColor() {
            return {
                'background-color': this.primary_color,
            }
        },
        filteredItems() {
            return Array.isArray(this.faq.items) ? this.faq.items
                .filter(item => !this.$lodash.isEmpty(item)) : []
        },
    },
}
</script>

<style lang="scss" scoped>
.card-content{
    padding: 0;
    margin-left: 3.25rem;
}

.card {
    background-color: #FBFBFD;
}
.card-header {
    background-color: #FBFBFD;
}

@media screen and (max-width: 768px) {
    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .card-content{
    padding: 0;
    margin-left: 2.0rem;
}
 }
</style>